// Show the given element
window.showIaError = (errorElement) => {
    errorElement.classList.add("ia-error__container_visible");
}

// Hide the given element
window.hideIaError = (errorElement) => {
    errorElement.classList.remove("ia-error__container_visible");
}

// Returns true if there are any visible ia errors on the page
checkForIaErrors = () => {
    const pageErrors = document.querySelectorAll(".ia-error__container_visible");
    return pageErrors.length > 0;
}

// Disable the specified button if any ia errors are present
window.toggleIaButton = (button) => {
    if (checkForIaErrors()) {
        button.classList.add("disabled");
        button.setAttribute("disabled", "disabled");
    } else {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
    }
}